module.exports = require("core-js/library/fn/symbol");


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime/core-js/symbol.js
// module id = ../node_modules/@babel/runtime/core-js/symbol.js
// module chunks = 0